export default __webpack_public_path__ + "static/media/Instagram.c6062d67.png";